import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Plus, Check, X } from "lucide-react";

export const LeaveTab = ({
  activeEmployees,
  leaveRequests,
  getEmployeeName,
  onNewLeaveRequest,
  onLeaveAction,
}) => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="text-lg">Leave Requests</CardTitle>
          <Button onClick={onNewLeaveRequest} className="bg-green-600 hover:bg-green-700" data-testid="new-leave-request-btn">
            <Plus className="h-4 w-4 mr-2" />
            New Leave Request
          </Button>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Employee</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>From</TableHead>
                <TableHead>To</TableHead>
                <TableHead>Days</TableHead>
                <TableHead>Reason</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {leaveRequests.map((request) => (
                <TableRow key={request.id} data-testid={`leave-request-${request.id}`}>
                  <TableCell className="font-medium">{getEmployeeName(request.employee_id)}</TableCell>
                  <TableCell className="capitalize">{request.leave_type}</TableCell>
                  <TableCell>{request.start_date}</TableCell>
                  <TableCell>{request.end_date}</TableCell>
                  <TableCell>{request.days}</TableCell>
                  <TableCell>{request.reason || "-"}</TableCell>
                  <TableCell>
                    <span className={`px-2 py-1 rounded text-xs ${
                      request.status === 'approved' ? 'bg-green-100 text-green-700' :
                      request.status === 'rejected' ? 'bg-red-100 text-red-700' :
                      'bg-yellow-100 text-yellow-700'
                    }`}>
                      {request.status.toUpperCase()}
                    </span>
                  </TableCell>
                  <TableCell>
                    {request.status === 'pending' && (
                      <div className="flex gap-2">
                        <Button 
                          variant="outline" 
                          size="sm"
                          className="text-green-600"
                          onClick={() => onLeaveAction(request.id, 'approved')}
                          data-testid={`approve-leave-${request.id}`}
                        >
                          <Check className="h-4 w-4" />
                        </Button>
                        <Button 
                          variant="outline" 
                          size="sm"
                          className="text-red-600"
                          onClick={() => onLeaveAction(request.id, 'rejected')}
                          data-testid={`reject-leave-${request.id}`}
                        >
                          <X className="h-4 w-4" />
                        </Button>
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {leaveRequests.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} className="text-center text-gray-500">
                    No leave requests
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      {/* Leave Balances */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Leave Balances</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Employee</TableHead>
                <TableHead>Annual Leave</TableHead>
                <TableHead>Sick Leave</TableHead>
                <TableHead>Family Leave</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {[...activeEmployees].sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((emp) => (
                <TableRow key={emp.id} data-testid={`leave-balance-${emp.id}`}>
                  <TableCell className="font-medium">{emp.first_name} {emp.last_name}</TableCell>
                  <TableCell>{emp.leave_balance?.annual || 0} days</TableCell>
                  <TableCell>{emp.leave_balance?.sick || 0} days</TableCell>
                  <TableCell>{emp.leave_balance?.family || 0} days</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};
